import React from 'react';
import Svg, { Circle, Ellipse, Line, Path, Polygon, Polyline, Rect } from 'react-native-svg';
import { ICON_PATHS } from './generated';
import type { IconName } from './generated';
import { useColors, useIconScale } from '../theme';

const ELEMENTS: Record<string, React.ComponentType<any>> = {
  path: Path,
  circle: Circle,
  line: Line,
  rect: Rect,
  polyline: Polyline,
  polygon: Polygon,
  ellipse: Ellipse,
};

export interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  /** Lucide draws on a 24px grid at stroke width 2; scale it for small sizes. */
  strokeWidth?: number;
}

export function Icon({
  name,
  size = 18,
  color,
  strokeWidth = 2,
}: IconProps) {
  const colors = useColors();
  const iconScale = useIconScale();
  const nodes = ICON_PATHS[name];
  const px = Math.round(size * iconScale);
  return (
    <Svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color ?? colors.textDim}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {nodes.map(([tag, attrs], i) => {
        const El = ELEMENTS[tag];
        return El ? <El key={i} {...attrs} /> : null;
      })}
    </Svg>
  );
}

export type { IconName };
export { ICON_PATHS };
